(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@material/switch", [], factory);
	else if(typeof exports === 'object')
		exports["switch"] = factory();
	else
		root["mdc"] = root["mdc"] || {}, root["mdc"]["switch"] = factory();
})(this, function() {
return 